module.exports = __webpack_public_path__ + "static/media/bayawonn.6d40cbfa.png";